var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8 0C7.5215 0 0 7.5215 0 16.8C0 26.0785 7.5215 33.6 16.8 33.6C26.0785 33.6 33.6 26.0785 33.6 16.8C33.6 7.5215 26.0785 0 16.8 0ZM20.7795 11.6095H18.2543C17.955 11.6095 17.6225 12.0033 17.6225 12.5265V14.35H20.7813L20.3035 16.9505H17.6225V24.7573H14.6423V16.9505H11.9385V14.35H14.6423V12.8205C14.6423 10.626 16.1648 8.84275 18.2543 8.84275H20.7795V11.6095Z",
    fill: "#FFBA33"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.cdc896c3e1ef494f434f8e3c73266e09.svg";
export { ForwardRef as ReactComponent };